<template>
    <div class="key-data-sup-change-audit">
        <div class="title">物流园变更</div>
        <div class="key-data-sup-change-info">
            <div class="title-container">
                <span class="sub-title">变更前</span>
                <i
                    :class="oldContentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                    @click="handleCollapseOld"></i>
            </div>
            <div class="content" v-if="oldContentVisible">
                <el-row v-for="(itemList, index) in beforeData" :key="index">
                    <template v-for="(item, chidIndex) in itemList">
                        <el-col class="has-bg right-text" :span="3">{{ item.label }}</el-col>
                        <el-col class="right-val" :span="5">
                            <el-button
                                class="preview-btn"
                                v-if="imageList.includes(item.label) && item.value !== '-'"
                                type="text"
                                @click="handlePreview(item)">
                                {{ getFileName(item,1) }}
                            </el-button>
                            <span v-else>{{ item.value }}</span>
                        </el-col>
                    </template>
                </el-row>
            </div>
        </div>
        <div class="key-data-sup-change-info">
            <div class="title-container">
                <span class="sub-title">变更后</span>
                <i
                    :class="newContentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                    @click="handleCollapseNew"></i>
            </div>
            <div class="content" v-if="newContentVisible">
                <el-row v-for="(itemList, index) in afterData" :key="index">
                    <template v-for="(item, chidIndex) in itemList">
                        <el-col class="has-bg right-text" :span="3">{{ item.label }}</el-col>
                        <el-col class="right-val" :span="5">
                            <el-button
                                class="preview-btn"
                                v-if="imageList.includes(item.label)"
                                type="text"
                                @click="handlePreview(item)">
                                {{ getFileName(item,2) }}
                            </el-button>
                            <span v-else>{{ item.value }}</span>
                        </el-col>
                    </template>
                </el-row>
            </div>
        </div>
        <Preview
            v-if="attachmentShow"
            :attachmentList="attachmentList"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"></Preview>
    </div>
</template>
<script>
import dayjs from 'dayjs'
import Preview from '../../../../../components/viewAttachment.vue'
import { dictWithUrl } from '@/components/lots/api'
import { formListConfig } from './basicConfig.js'
import { changeApplyInfoIFlow } from '../../../../../api/addPhysicalStorage.js'
const FORMLIST = [
    {
        title: '',
        items: [
            {
                label: '上传仓库评审方案',
                value: '0',
                prop: 'warehouseFileUrl',
                type: 'span',
                disabled: true,
            },
            {
                label: '上传仓库寻源信息登记表',
                value: '0',
                prop: 'warehouseInfoFileUrl',
                type: 'span',
                disabled: true,
            },
            {
                label: '其他附件（可打包）',
                value: '0',
                prop: 'warehouseOtherFileUrl',
                type: 'span',
                disabled: true,
            },
        ],
    },
]
const imageList = ['上传仓库评审方案', '上传仓库寻源信息登记表', '其他附件（可打包）']

export default {
    components: { Preview },
    props: {
        auditId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            oldContentVisible: true,
            newContentVisible: true,
            dictData: {},
            beforeDto: [],
            afterDto: [],
            beforeData: [],
            afterData: [],
            attachmentShow: false,
            rowData: {},
            attachmentList: [],
            imageList,
        }
    },
    methods: {
        getFileName(item, type) {
            const { label, value } = item
            if(value === '-') {
                return value
            }
            let fileName = ''
            try{
                fileName = label.replace('上传', '')
                let key = ''
                if(label === '上传仓库评审方案'){
                    key = 'warehouseFileName'
                }
                else if(label === '上传仓库寻源信息登记表'){
                    key = 'warehouseInfoFileName'
                }
                else if(label === '其他附件（可打包）'){
                    key = 'warehouseOtherFileName'
                }
                // console.log(item, type, key)
                if(key) {
                    fileName = type === 1 ? this.beforeDto[key] : this.afterDto[key]
                }
            }
            catch(error) {
                fileName = label
            }
            return fileName
        },
        handlePreview(data) {
            if(data.value === '-') return
            console.log('handlePreview', data)
            this.rowData = {
                downUrl: data.value,
                fileName: data.label,
                fileId: data.label,
            }
            this.attachmentShow = true
        },
        loadData() {
            let params = {
                fdId: this.auditId,
            }
            changeApplyInfoIFlow(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.setFormData(res.data)
                    }
                })
                .catch(err => {})
        },
        findLabel(prop) {
            let allList = formListConfig.concat(FORMLIST)
            let label = ''
            for (const item of allList) {
                let items = item.items
                if (Array.isArray(items)) {
                    for (const child of items) {
                        if (child.prop === prop) {
                            label = child.label
                            break
                        }
                    }
                }
            }
            return label
        },

        chunkArray(arr, chunkSize = 3) {
            const result = []
            for (let i = 0; i < arr.length; i += chunkSize) {
                // 用slice截取当前块，从i到i+chunkSize
                result.push(arr.slice(i, i + chunkSize))
            }
            return result
        },
        timeformat(time) {
            return time ? dayjs(time).format('YYYY-MM-DD') : '-'
        },
        handleCollapseOld() {
            this.oldContentVisible = !this.oldContentVisible
        },
        handleCollapseNew() {
            this.newContentVisible = !this.newContentVisible
        },
        setFormData(data) {
            const { beforeDto, afterDto, changeFieldEnList } = data
            this.beforeData = []
            this.afterData = []
            let beforeList = []
            let afterList = []
            beforeDto.specialApproveFlag = this.dictData.SRM_SPECIAL_FLAG[beforeDto.specialApproveFlag + '']
            afterDto.specialApproveFlag = this.dictData.SRM_SPECIAL_FLAG[beforeDto.afterDto + '']

            beforeDto.propertyType = this.dictData.SYS_PROPERTY_RIGHTS[beforeDto.propertyType + '']
            afterDto.propertyType = this.dictData.SYS_PROPERTY_RIGHTS[afterDto.propertyType + '']

            beforeDto.manageType = this.dictData.SRM_WH_MANAGE_ATTRIBUTES[beforeDto.manageType + '']
            afterDto.manageType = this.dictData.SRM_WH_MANAGE_ATTRIBUTES[afterDto.manageType + '']

            beforeDto.landUse = this.dictData.SRM_PW_LAND_USE[beforeDto.landUse + '']
            afterDto.landUse = this.dictData.SRM_PW_LAND_USE[afterDto.landUse + '']

            beforeDto.isSublet = this.dictData.SRM_YES_NO[beforeDto.isSublet + '']
            afterDto.isSublet = this.dictData.SRM_YES_NO[afterDto.isSublet + '']

            beforeDto.propertyQualificationFlag = this.dictData.SRM_YES_NO[beforeDto.propertyQualificationFlag + '']
            afterDto.propertyQualificationFlag = this.dictData.SRM_YES_NO[afterDto.propertyQualificationFlag + '']

            beforeDto.whType = this.dictData.SYS_SU_WH_TYPE[beforeDto.whType + '']
            afterDto.whType = this.dictData.SYS_SU_WH_TYPE[afterDto.whType + '']

            beforeDto.poweredSystemFlag = this.dictData.SRM_WH_POWER_SYSTEM[beforeDto.poweredSystemFlag + '']
            afterDto.poweredSystemFlag = this.dictData.SRM_WH_POWER_SYSTEM[afterDto.poweredSystemFlag + '']

            beforeDto.drainageSystem = this.dictData.SRM_DRAINAGE_SYSTEM[beforeDto.drainageSystem + '']
            afterDto.drainageSystem = this.dictData.SRM_DRAINAGE_SYSTEM[afterDto.drainageSystem + '']

            beforeDto.platform = this.dictData.SYS_SU_PLATFORM[beforeDto.platform + '']
            afterDto.platform = this.dictData.SYS_SU_PLATFORM[afterDto.platform + '']

            beforeDto.canopy = this.dictData.SYS_SU_CANOPY[beforeDto.canopy + '']
            afterDto.canopy = this.dictData.SYS_SU_CANOPY[afterDto.canopy + '']

            beforeDto.pressure = this.dictData.SYS_SU_PRESSURE[beforeDto.pressure + '']
            afterDto.pressure = this.dictData.SYS_SU_PRESSURE[afterDto.pressure + '']

            beforeDto.buildingType = this.dictData.SYS_SU_BUILDING_TYPE[beforeDto.buildingType + '']
            afterDto.buildingType = this.dictData.SYS_SU_BUILDING_TYPE[afterDto.buildingType + '']
            beforeDto.withLighting = this.dictData.SYS_SU_WITH_LIGHTING[beforeDto.withLighting + '']
            afterDto.withLighting = this.dictData.SYS_SU_WITH_LIGHTING[afterDto.withLighting + '']

            beforeDto.groundDust = this.dictData.SYS_SU_GROUND_DUST[beforeDto.groundDust + '']
            afterDto.groundDust = this.dictData.SYS_SU_GROUND_DUST[afterDto.groundDust + '']

            beforeDto.lightingSystem = this.dictData.SYS_SU_LIGHTING_SYSTEM[beforeDto.lightingSystem + '']
            afterDto.lightingSystem = this.dictData.SYS_SU_LIGHTING_SYSTEM[afterDto.lightingSystem + '']

            beforeDto.fireInspection = this.dictData.SYS_SU_FIRE_INSPECTION[beforeDto.fireInspection + '']
            afterDto.fireInspection = this.dictData.SYS_SU_FIRE_INSPECTION[afterDto.fireInspection + '']

            beforeDto.fireFacilities = this.dictData.SYS_SU_FIRE_FACILITIES[beforeDto.fireFacilities + '']
            afterDto.fireFacilities = this.dictData.SYS_SU_FIRE_FACILITIES[afterDto.fireFacilities + '']

            beforeDto.parkPath = this.dictData.SYS_SU_PARK_PATH[beforeDto.parkPath + '']
            afterDto.parkPath = this.dictData.SYS_SU_PARK_PATH[afterDto.parkPath + '']

            beforeDto.officeFlag = this.dictData.SRM_WH_OFFICE[beforeDto.officeFlag + '']
            afterDto.officeFlag = this.dictData.SRM_WH_OFFICE[afterDto.officeFlag + '']

            beforeDto.dormFlag = this.dictData.SRM_WH_DORM[beforeDto.dormFlag + '']
            afterDto.dormFlag = this.dictData.SRM_WH_DORM[afterDto.dormFlag + '']

            beforeDto.factoryFlag = this.dictData.SRM_YES_NO[beforeDto.factoryFlag + '']
            afterDto.factoryFlag = this.dictData.SRM_YES_NO[afterDto.factoryFlag + '']

            beforeDto.factorySign = this.dictData.SRM_WAREHOUSE_FACTORY_SIGN[beforeDto.factorySign + '']
            afterDto.factorySign = this.dictData.SRM_WAREHOUSE_FACTORY_SIGN[afterDto.factorySign + '']

            beforeDto.warehouseLevel = this.dictData.SRM_REGISTER_WAREHOUSE_LEVEL[beforeDto.warehouseLevel + '']
            afterDto.warehouseLevel = this.dictData.SRM_REGISTER_WAREHOUSE_LEVEL[afterDto.warehouseLevel + '']

            beforeDto.landProperty = this.dictData.SRM_REGISTER_WAREHOUSE_LEVEL[beforeDto.landProperty + '']
            afterDto.landProperty = this.dictData.SRM_REGISTER_WAREHOUSE_LEVEL[afterDto.landProperty + '']
            
            this.beforeDto = beforeDto
            this.afterDto = afterDto
            for (const item of changeFieldEnList) {
                let beforeRow = {
                    label: this.findLabel(item),
                    value: beforeDto[item] || '-',
                }
                let afterRow = {
                    label: this.findLabel(item),
                    value: afterDto[item] || '-',
                }
                beforeList.push(beforeRow)
                afterList.push(afterRow)
            }

            this.beforeData = this.chunkArray(beforeList, 3)
            this.afterData = this.chunkArray(afterList, 3)
        },
    },
    mounted() {
        // 是否特批 SRM_SPECIAL_FLAG
        // 产权属性 SYS_PROPERTY_RIGHTS
        // 管理属性 SRM_WH_MANAGE_ATTRIBUTES
        // 土地用途 SRM_PW_LAND_USE
        // 是否涉及转租 SRM_YES_NO
        // 仓库类型 SYS_SU_WH_TYPE
        // 备用发电机 SRM_WH_POWER_SYSTEM
        // 排水系统 SRM_DRAINAGE_SYSTEM
        // 月台 SYS_SU_PLATFORM
        // 雨棚 SYS_SU_CANOPY
        // 地面承压 SYS_SU_PRESSURE
        // 建筑结构 SYS_SU_BUILDING_TYPE
        // 采光带占比 SYS_SU_WITH_LIGHTING
        // 地面防尘 SYS_SU_GROUND_DUST
        // 照明系统 SYS_SU_LIGHTING_SYSTEM
        // 消防验收 SYS_SU_FIRE_INSPECTION
        // 消防设施 SYS_SU_FIRE_FACILITIES
        // 园区通道 SYS_SU_PARK_PATH
        // 员工宿舍 SRM_WH_DORM
        // 是否地产商 SRM_YES_NO
        // 地产商简称 SRM_WAREHOUSE_FACTORY_SIGN
        // 仓库等级 SRM_REGISTER_WAREHOUSE_LEVEL
        // 仓库等级 SRM_WH_OFFICE
        // 土地性质 SRM_PW_LAND_PROPERTY
        dictWithUrl(
            'SRM_SPECIAL_FLAG,SYS_PROPERTY_RIGHTS,SRM_WH_MANAGE_ATTRIBUTES,SRM_PW_LAND_USE,SRM_YES_NO,SYS_SU_WH_TYPE,SRM_WH_POWER_SYSTEM,' +
            'SRM_DRAINAGE_SYSTEM,SYS_SU_PLATFORM,SYS_SU_CANOPY,SYS_SU_PRESSURE,SYS_SU_BUILDING_TYPE,SYS_SU_WITH_LIGHTING,SYS_SU_GROUND_DUST,SRM_WH_OFFICE,' +
            'SYS_SU_LIGHTING_SYSTEM,SYS_SU_FIRE_INSPECTION,SYS_SU_FIRE_FACILITIES,SYS_SU_PARK_PATH,SRM_WH_DORM,SRM_WAREHOUSE_FACTORY_SIGN,SRM_REGISTER_WAREHOUSE_LEVEL,' +
            'SRM_PW_LAND_PROPERTY', 
        )
        .then(res => {
            if (res && +res.code === 0) {
                    this.dictData = res.data
                    this.loadData()
                }
            })
            .catch(err => {})
    },
}
</script>
<style lang="less" scoped>
.key-data-sup-change-audit {
    color: #000;

    .title {
        margin-bottom: 15px;
        font-size: 16px;
        font-weight: bold;
    }
}

.key-data-sup-change-info {
    margin-bottom: 20px;
    font-size: 14px;
    color: #000;

    .el-row {
        display: flex;
    }

    .el-col {
        float: none;
    }
    .change-type-label {
        margin-bottom: 10px;
        font-weight: bold;
    }

    .sub-title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .title-container {
        margin-bottom: 5px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }

    .content {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .has-bg {
        background: #f5f7fa;
    }

    .right-text {
        text-align: right;
    }
    // .right-val {
    //     // color: #f83706;
    // }

    .el-col {
        padding: 5px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        min-height: 30px;
    }

    .wrap-label-row .el-col {
        min-height: 50px;
    }

    .no-wrap {
        white-space: nowrap;
    }
}
</style>
